<template>
  <div :class="css" class="rounded border w-full">
    <div class="flex justify-start items-center">
      <span class="pr-5">
        <font-awesome-icon :icon="icon"></font-awesome-icon>
      </span>
      <div class="" v-if="withDatetime" v-text="datetime"></div>
      <p v-html="message" class="py-1"></p>
    </div>
  </div>
</template>

<script>
import moment from "moment";

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

export default {
  props: {
    message: {
      type: String,
      required: true,
    },
    level: {
      type: String,
      required: false,
      default: "info",
    },
    withDatetime: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components: {},
  mixins: [],
  data: function () {
    return {
      icons: {
        info: "info-circle",
        success: "check-circle",
        warning: "exclamation-circle",
        danger: "exclamation-circle",
        error: "exclamation-circle",
      },
      classes: {
        info: "border-blue-200 bg-blue-100 text-blue-800",
        success: "border-green-200 bg-green-100 text-green-800",
        warning: "border-orange-200 bg-orange-100 text-orange-800",
        danger: "border-red-200 bg-red-100 text-red-800",
        error: "border-red-200 bg-red-100 text-red-800",
      },
    };
  },
  methods: {},
  computed: {
    css() {
      if (hasOwnProperty(this.classes, this.level)) {
        return this.classes[this.level];
      }

      return this.classes["info"];
    },

    icon() {
      if (hasOwnProperty(this.icons, this.level)) {
        return this.icons[this.level];
      }

      return this.icons["info"];
    },

    datetime() {
      let datetime = moment().locale(this.locale);
      return datetime.format("dddd LL") + " " + datetime.format("LTS");
    },

    locale() {
      return this.$route.params.locale;
    },
  },
  mounted() {},
};
</script>

<style></style>
